// src/pages/admin/AdminDashboard.jsx

import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthProvider";

export default function AdminDashboard() {
  const { user } = useAuth();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Admin Dashboard</h1>
      <p className="mb-4 text-gray-600">
        Welcome {user?.full_name}. Use the links below to manage the system.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link
          to="/admin/pending-users"
          className="block p-4 border rounded-lg shadow hover:bg-gray-50"
        >
          <h2 className="font-semibold mb-1">Pending Users</h2>
          <p className="text-sm text-gray-600">
            Approve or reject user registrations
          </p>
        </Link>

        <Link
          to="/admin/companies"
          className="block p-4 border rounded-lg shadow hover:bg-gray-50"
        >
          <h2 className="font-semibold mb-1">Companies</h2>
          <p className="text-sm text-gray-600">
            Create and manage tenant companies
          </p>
        </Link>

        <Link
          to="/admin/access-control"
          className="block p-4 border rounded-lg shadow hover:bg-gray-50"
        >
          <h2 className="font-semibold mb-1">Manager Permissions & PO Authority</h2>
          <p className="text-sm text-gray-600">
            Configure Manager access, cost-centre scope and PO approval limits
          </p>
        </Link>
      </div>
    </div>
  );
}
